// Kopfzeilen-Checkbox mit data-check-all="<Name>": wählt alle Checkboxen
// dieses Namens im selben Formular aus oder ab - auch solche, die nur über das
// form-Attribut dazugehören (Sammelaktion der Domain-Tags). Ohne JavaScript
// bleibt sie verborgen; die Zeilen lassen sich dann einzeln wählen.
export default function checkAll() {
  document.querySelectorAll('input[type=checkbox][data-check-all]').forEach(function (master) {
    if (!master.form) return;
    const boxes = Array.from(master.form.elements).filter(function (el) {
      return el !== master && el.type === 'checkbox' && el.name === master.dataset.checkAll;
    });
    if (boxes.length === 0) return;

    const sync = function () {
      const checked = boxes.filter(function (box) { return box.checked; }).length;
      master.checked = checked === boxes.length;
      master.indeterminate = checked > 0 && checked < boxes.length;
    };
    master.hidden = false;
    master.addEventListener('change', function () {
      boxes.forEach(function (box) { box.checked = master.checked; });
    });
    boxes.forEach(function (box) { box.addEventListener('change', sync); });
    sync();
  });
}
